import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { ArrowLeft } from '@peacecover/icon';

interface ProfileImagePreviewProps {
  bettieProfileImage: string;
  previewObjectUrl: string | null;
  clearBettieProfileImage: () => void;
  onConfirm: () => void;
}

const ProfileImagePreview = ({
  bettieProfileImage,
  previewObjectUrl,
  clearBettieProfileImage,
  onConfirm
}: ProfileImagePreviewProps) => {
  const handleBackClick = () => {
    clearBettieProfileImage();
  };

  return (
    <div className="bg-pure-black min-h-screen pt-[env(safe-area-inset-top)] fixed inset-0 flex flex-col">
      <header className="fixed top-[env(safe-area-inset-top)] left-0 right-0 z-50 p-[16px]">
        <ArrowLeft size={24} className="text-main-dark-1" onClick={handleBackClick} />
      </header>
      <div className="flex-1 flex flex-col items-center justify-center px-[24px] pt-[80px] pb-[200px]">
        <img
          src={previewObjectUrl || bettieProfileImage || ''}
          alt="selectedImage"
          className="w-[218px] h-[218px] rounded-full object-cover"
        />
      </div>
      <div className="fixed left-0 right-0 bg-pure-black px-[24px] bottom-0 pb-[calc(env(safe-area-inset-bottom)+10px)]">
        <Button size="large" className="w-full text-[17px] font-semibold" onClick={onConfirm}>
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
};
export default ProfileImagePreview;
